<!--
 * @Author: Cathy
 * @Date: 2020-02-25 15:11:29
 * @LastEditors: yezi
 * @LastEditTime: 2020-06-24 09:21:30
 * @Description: 使用说明
 -->
<template>
 <div class="useDirection">
    <topMenu type="useDirection" pageType="recommend" />
    <catalogue :list="list" />
    <div class="detail">
        <div class="tItem" v-for="(item, index) in list" :key="index" @click="directionsDetail(item)">
          <img :src="item.pt_page" />
          <a :id="'title'+ index" />
          <p>{{index + 1}}.{{item.title}}</p>
          <!-- <div v-html="item.content" style="margin-top: 0.4rem"></div> -->
        </div>
    </div>
 </div>
</template>

<script>
import topMenu from '../components/topMenu'
import catalogue from '../components/catalogue'
import { getList } from '../api/wap'
export default {
  name: 'useDirection',
  components: {
    topMenu,
    catalogue
  },
  data () {
    return {
      list: []
    }
  },
  created () {
    this.onLoadData()
  },
  methods: {
    onLoadData () {
      getList({ type: 2 })
        .then(res => {
          this.list = res.result.list
        })
    },
    directionsDetail (e) {
      localStorage.setItem('content', e.content)
      this.$router.push({
        path: '/directionsDetail',
        query: {
          // content: e.content,
          title: e.title
        }
      })
    }
  }
}
</script>

<style scoped>
.detail {
  padding: 0.3rem 0.1rem 1rem;
  display: flex;
  flex-wrap: wrap;
}
.detailItem {
  margin-top: 0.4rem;
  padding: 0.4rem;
  border-radius: 0.16rem;
  box-shadow:0 0 0.46rem 0 rgba(4,0,0,0.13);
}
.detailItem p {
    color: #121212;
    font-size: 0.34rem;
    font-weight: bold;
}
.tItem {
  margin-top: 0.59rem;
  width: 3.45rem;
  border:1px solid rgba(188,188,188,1);
  border-radius:0.1rem;
  margin-left: 0.1rem;
  margin-right: 0.1rem;
  padding-bottom: 0.2rem;
}
.tItem  p{
  color: #121212;
  font-size: 0.26rem;
  padding: 0.2rem 0.2rem 0;
  overflow:hidden;
  text-overflow:ellipsis;
  display:-webkit-box;
  -webkit-box-orient:vertical;
  -webkit-line-clamp:1;
}
.tItem img {
  width: 100%;
  height: 1.95rem;
  background-color: #121212;
}
</style>
